<div class="main-content">
  <div class="header_container">
    <div class="inlineBlock user-search-count">
      <span class="title">Clients</span>
      <span class="user-count" *ngIf="pagination.totalCount > 0">{{
        pagination.totalCount
      }}</span>
      <span class="search-user">
        <mat-form-field appearance="outline">
          <mat-label>Search name or email</mat-label>
          <input
            matInput
            placeholder="Search name or email"
            (keyup)="onSearchUser($event)"
            autocomplete="off"
          />
          <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>
        <mat-slide-toggle
          class="search-user"
          color="primary"
          [checked]="isShowCompancyClients"
          (change)="showCompanyClient($event)"
        >
          Show Company Clients
        </mat-slide-toggle>
      </span>
    </div>
    <div class="inlineBlock add-user">
      <span>
        <button mat-raised-button color="primary" class="add-user-btn" (click)="addUser()">
          <mat-icon>add_circle</mat-icon>
          Add User
        </button>
      </span>
    </div>
  </div>
  <div class="table-container">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

      <!-- Position Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let element">
          {{ element.firstname }} {{ element.lastname }}
          <br />
          <span class="label" (click)="specificUser(element)">{{
            element.email
          }}</span>
        </td>
      </ng-container>

      <!-- Consultant Column -->
      <ng-container matColumnDef="consultant">
        <th mat-header-cell *matHeaderCellDef>Consultant</th>
        <td mat-cell *matCellDef="let element">
          {{ element?.consultant?.firstname }}
          {{ element?.consultant?.lastname }}
        </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="progress">
        <th mat-header-cell *matHeaderCellDef>Progress</th>
        <td mat-cell *matCellDef="let element">
          {{ element.progress }}
        </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">
          <mat-slide-toggle
            class="p-status"
            (change)="statusUpdate($event, element.id)"
            [checked]="element.enabled ? true : false"
          ></mat-slide-toggle>
        </td>
      </ng-container>

      <ng-container matColumnDef="settings">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-raised-button
            class="settings"
            (click)="navigateToSettings(element)"
          >
            <mat-icon>build</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <span *ngIf="!dataSource.length" class="emtmsg">No records found</span>
    <mat-paginator
      *ngIf="pagination.totalCount > 10"
      [length]="pagination.count"
      [pageIndex]="pagination.pageIndex"
      [pageSize]="pagination.perPage"
      [pageSizeOptions]="[10, 25, 50, 100, 200]"
      (page)="getServerData($event)"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>